import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// Component imports
import Header from './components/Header';
import Footer from './components/Footer';

// Page imports 
import Home from './pages/Home';
import About from './pages/About';
import Projects from './pages/Projects';
import Contact from './pages/Contact';
import SingleProject from './pages/SingleProject';

function AppRouter() {
  return (
    <Router>
      <div className="wrapper">
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/project/:projectID" element={<SingleProject />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default AppRouter;